import AgreedCards from './Card/AgreedCards'
import NotAgreedCards from './Card/NotAgreedCards'

export { AgreedCards, NotAgreedCards }
